export default __webpack_public_path__ + "static/media/Results.05301dc6.webp";